export const safeDateParse = (stringDate: string | null | undefined) =>
  stringDate ? new Date(stringDate) : null;
